// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Angola from '../_raw/flag/icon_flag_angola.png';

export default () => <img src={Angola} alt="Angola" />;
